import { get } from '@_shared/config';
import { announcementModel } from '../model';

export function getAnnouncementList() {
	return get<announcementModel.IAnnouncementListResponse>('/settings/support/announcement');
}

export async function getAnnouncement(id: string | number) {
	return get<announcementModel.IAnnouncement>(`/settings/support/announcement/${id}`);
}
